import Banner from "../../components/banner/Banner"
import Stories from "../../components/stories/Stories"
import Targets from "../../components/targets/Targets"
import GeoTable from "../../components/geo/GeoTable"
import Cases from "../../components/cases/Cases"
import Posts from "../../components/posts/Posts"
import Share from "../../components/share/Share"
import "./home.scss"
import GeoPost from "../../components/geo/GeoPost"

const Home = () => {
  return (
    <div className="home">
    <Banner title="Home"/>
      <Share/>

      <Cases/>
      <GeoTable/>
      <Posts/>
    </div>
  )
}

export default Home